import React, { useState, useEffect } from 'react';
import { Select, Typography, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import * as API from '../services/api';
import { useTheme } from '../context/ThemeContext';
import { useAuth } from '../context/AuthContext';
import { useThemeStyles } from '../context/ThemeContext';

const { Title } = Typography;

const Chat = () => {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const { token } = useAuth();
  const themeStyles = useThemeStyles();
  const [loading, setLoading] = useState(false);
  const [deployments, setDeployments] = useState([]);

  useEffect(() => {
    const fetchDeployments = async () => {
      setLoading(true);
      try {
        if (!token) {
          setDeployments([]);
          return;
        }
        const response = await API.listRbacProjects(token);
        const data = Array.isArray(response.data) ? response.data : [];
        const deployedProjects = data
          .filter((p) => {
            const meta = p.meta || {};
            if (meta.deleted) return false;
            if (p.chat_available != null) return Boolean(p.chat_available);
            return (
              meta.embedding_status === 'completed' &&
              meta.vector_status === 'completed'
            );
          })
          .map((p) => ({ id: p.project_id, name: p.name }));
        setDeployments(deployedProjects);
      } catch (error) {
        console.error('Error fetching deployments:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchDeployments();
  }, [token]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', flexDirection: 'column', gap: '20px' }}>
      <Title level={2} style={{ 
        margin: 0, 
        color: themeStyles.textPrimary,
        textShadow: 'none'
      }}>
        Select a project
      </Title>
      <Select
        placeholder="Choose a project to chat with"
        style={{ width: 400 }}
        size="large"
        onChange={(value) => navigate(`/chat/${value}`)}
        options={deployments.map(d => ({ value: d.id, label: d.name }))}
      />
    </div>
  );
};

export default Chat;
